const CLASS_LOADED = 'is-loaded';
const CLASS_BUTTON_LOADING = 'is-button-loading';

export default class MediaBlock {
    constructor(element) {
        this.el = element;
        this.player = null;
        this.rect = null;
        this.active = false;

        this.initialize();
        this.connect();
    }

    initialize() {
        this.onPlayerReady = this.onPlayerReady.bind(this);
        this.onPlayerStateChange = this.onPlayerStateChange.bind(this);
        this.run = this.run.bind(this);
        this.activate = this.activate.bind(this);
        this.onError = this.onError.bind(this);
    }

    connect() {
        if (!this.el) return;

        this.iframe = this.el.querySelector('[media-block-iframe]');
        if (!this.iframe) {
            console.warn("MediaBlock instance missing '[media-block-iframe]' element");
            return;
        }
        this.id = this.iframe.getAttribute('media-block-iframe');

        this.video = this.el.querySelector('[media-block-video]');
        if (!this.video) {
            console.warn("MediaBlock instance missing '[media-block-video]' element");
            return;
        }

        this.button = this.el.querySelector('[media-block-button]');
        if (!this.button) {
            console.warn("MediaBlock instance missing '[media-block-button]' element");
            return;
        }
        this.buttonTextEls = Array.from(this.button.querySelectorAll('[button-text]')) || [];
        this.defaultButtonText = this.buttonTextEls[0]?.innerHTML || '';

        if (document.readyState === 'complete') {
            this.run();
        } else {
            window.addEventListener("load", this.run);
        }
    }

    disconnect() {
        window.removeEventListener("load", this.run);
        if (this.player) {
            this.player.destroy();
        }
    }

    run() {
        this.rect = this.video.getBoundingClientRect();

        // Load the YouTube IFrame API dynamically
        if (!window.YT) {
            const tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            document.body.appendChild(tag);

            window.onYouTubeIframeAPIReady = () => this.loadPlayer();
        } else {
            this.loadPlayer();
        }

        this.button.addEventListener("click", this.activate);
    }

    loadPlayer() {
        this.player = new YT.Player(this.iframe, {
            height: this.rect.height,
            width: this.rect.width,
            videoId: this.id,
            playerVars: {
                iv_load_policy: 3,
                modestbranding: 1,
                rel: 0,
                showinfo: 0
            },
            events: {
                'onReady': this.onPlayerReady,
                'onStateChange': this.onPlayerStateChange,
                'onError': this.onError
            }
        });
    }

    onPlayerReady() {
        if (this.active) {
            this.player.playVideo();
        }
    }

    onPlayerStateChange(event) {
        if (event.data === YT.PlayerState.PLAYING) {
            this.video.classList.add(CLASS_LOADED);
            this.button.classList.remove(CLASS_BUTTON_LOADING);
        } else if (event.data === YT.PlayerState.ENDED) {
            this.active = false;
            this.video.classList.remove(CLASS_LOADED);
        }
    }

    onError() {
        this.button.classList.remove(CLASS_BUTTON_LOADING);
        this.buttonUpdateText('Error');
    }

    buttonUpdateText(newText) {
        this.buttonTextEls.forEach(el => {
            el.innerHTML = newText;
        });
    }

    activate() {
        if (this.active) return;
        this.active = true;
        this.button.classList.add(CLASS_BUTTON_LOADING);

        if (this.player) {
            this.player.playVideo();
        }
    }
}
